module.exports = {"modals":{"multiple-elements-select":{"header":"Please select a booking","intro":"There are multiple bookings on the selected table {{element_name}}. Please select one to show details:","heads":{"booking_number":"#","customer_number":"Cnr","full_name":"Name","company_name":"Company","pax":"Pax"},"actions":{"show_details":"Show details"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/seatplans.json
// module id = 2405
// module chunks = 1